<template>

<v-content>

			<v-row justify="center" align="start">
				<v-col cols="12">

					<div v-for="category in categories" :key="category.id">
						<!-- recorrido padre : categories -->
						<h3>{{ category.nameFR }} {{ category.subtitleFR }}</h3>
								<hr>
								<!-- recorrido hijos : category > Items -->
								<v-list three-line>
									<div v-for="item in items" :key="item.id">
										<v-list-item v-if="item.category_id === category.id">
											<v-list-item-content>
												<v-list-item-title v-text="item.nameFR"></v-list-item-title>
												<v-list-item-subtitle v-text="item.descriptionFR"></v-list-item-subtitle>
												<v-list-item-subtitle v-text="item.description1FR"></v-list-item-subtitle>
												<v-list-item-subtitle v-text="item.description2FR"></v-list-item-subtitle>

												<v-row  class=" px-2 ">
											<p   v-for="aler in  item.alergenos" :key="aler.id" >
											<img style=" max-width: 24px; margin: 04px;" class="alergenos" :src="`/static/alergenos/${aler}.jpg`" />
											</p>

											</v-row>
											</v-list-item-content>
											<v-list-item-icon>
												<span v-text="item.price"></span>
											</v-list-item-icon>
										</v-list-item>
									</div>
								</v-list>

					</div>
				</v-col>
			</v-row>

          <v-spacer class="pa-10" ></v-spacer>
</v-content>

</template>

<script>
	import { mapState, mapActions } from "vuex";
	import { db } from "@/main";
	export default {
		created(){

			//this.getBussiness(this.$route.params.id)
			this.setLocalBusiness(this.$route.params.id)

			if (this.business !== '' ) {
				this.getCategories(this.$route.params.id)
				this.getItems(this.$route.params.id)
			}


		},
		data: () => ({
      businessId: '',
			loaded: false,
			categories: [],
			items: []
		}),
		methods: {
			...mapActions('businessModule',["setLocalBusiness",]),

			// Busco las categorias y las cargo en el array categories
			async getCategories(buss_id){
				let cats = []
				await db.collection('bussiness').doc(buss_id)
					.collection('categories').where('visible','==', true).orderBy('order')
					.onSnapshot(snap => {
						snap.forEach(doc => {
							cats.push({ id: doc.id, ...doc.data() })
						})
						this.categories = cats;
					})

			}, //.getCategories

			// Busco los items y los cargo en el array item
			async getItems(buss_id){
				let its = []
				await db.collection('bussiness').doc(buss_id)
					.collection('items').where('visible','==', true).orderBy('order')
					.onSnapshot(snap => {
						snap.forEach(doc => {
							its.push({ id: doc.id, ...doc.data() })
						})
						this.items = its;
						this.loaded = true;
					})

			}, //.getCategories



		}, //.methods
		computed: {
			...mapState('businessModule',["business",]),
		},


	}
</script>

<style>

</style>
